import { Button, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useState } from "react";
import NotSet from "../../../components/NotSet";
import { ListingProperties } from "../../../types/listing.type";
import ListingModal from "../Components/ListingModal";
import { ListingViewItem } from "./interface";

interface Props {
	items: ListingViewItem[];
}
const ListingListTable: React.FC<Props> = ({ items }) => {
	const [showDetail, setShowDetail] = useState<ListingProperties | undefined>();

	const COLUMNS: ColumnsType<ListingViewItem> = [
		{
			title: "LISTING ID",
			dataIndex: "listingCode",
			key: "listingCode",
			width: 150,
			render: (value: string, record: ListingViewItem) => (
				<Button
					style={{ padding: 0 }}
					type="link"
					onClick={() => setShowDetail(record)}
				>
					{value ?? <NotSet />}
				</Button>
			),
		},
		{
			title: "AGENT",
			dataIndex: ["agent", "name"],
			key: "agentName",
			width: 200,
		},
		{
			title: "TITLE",
			dataIndex: "title",
			key: "title",
		},
		{
			title: "ADDRESS",
			dataIndex: "streetName",
			key: "streetName",
			// ellipsis: true,
			render(value, record, index) {
				return value + ", " + record.city;
			},
		},
	];

	return (
		<React.Fragment>
			<Table
				columns={COLUMNS}
				dataSource={items}
				size="small"
				pagination={false}
				scroll={{
					y: 615,
				}}
				rowKey="listingId"
				locale={{
					emptyText: "Listing Empty",
				}}
			/>
			<ListingModal
				open={showDetail !== undefined}
				onClose={() => setShowDetail(undefined)}
				listing={showDetail}
			/>
		</React.Fragment>
	);
};
export default ListingListTable;
